import { render, staticRenderFns } from "./AddTagsModalThemes.vue?vue&type=template&id=34317763&"
import script from "./AddTagsModalThemes.vue?vue&type=script&lang=js&"
export * from "./AddTagsModalThemes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports